import { render, staticRenderFns } from "./friends-list.vue?vue&type=template&id=364bebac&scoped=true"
import script from "./friends-list.vue?vue&type=script&lang=ts"
export * from "./friends-list.vue?vue&type=script&lang=ts"
import style0 from "./friends-list.vue?vue&type=style&index=0&id=364bebac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364bebac",
  null
  
)

export default component.exports